<template>
<div class="container users-detail-page">
    <v-head></v-head>
    <v-left current="users"></v-left>
    <div v-if="loading" class="my-loading"><i class="el-icon-loading"></i></div>
    <div v-else-if="detail" class="o-detail-con relative">
      <div class="o-main o-d-block">
        <div class="he-tips">
          <b style="font-size:16px;">用户详情</b>
          <div class="handle-s">
                <el-radio-group v-model="detail.agent_level" @change="changeAgentLevel">
                    <el-radio label="1">一级代理</el-radio>
                    <el-radio label="2">二级代理</el-radio>
                    <el-radio label="10">普通用户</el-radio>
                </el-radio-group>
          </div>
        </div>
        <table class="table">
          <tr>
            <td class="td-1">昵称</td>
            <td class="td-2">
              <img v-if="detail.avatar" :src="detail.avatar" style="width:32px;height:32px;">
              <span v-if="detail.avatar" class="deli-s">|</span>
              <span v-if="detail.nick_name">{{detail.nick_name}}</span>
              <span v-if="detail.nick_name" class="deli-s">|</span>
              <span>{{detail.gender}}</span>
              <span v-if="detail.gender" class="deli-s">|</span>
              <span>{{detail.uid}}</span>
            </td>
          </tr>
          <tr>
            <td class="td-1">城市</td>
            <td class="td-2">{{detail.contry}} {{detail.province}} {{detail.city}}</td>
          </tr>
          <tr>
            <td class="td-1">应用</td>
            <td class="td-2"><span>{{detail.app_name}}/{{detail.platformShow.label}}</span></td>
          </tr>
          <tr>
            <td class="td-1">累计充值</td>
            <td class="td-2">¥{{detail.bill_total}}</td>
          </tr>
          <tr>
            <td class="td-1">累计收入</td>
            <td class="td-2">{{detail.income_total}}</td>
          </tr>
          <tr>
            <td class="td-1">累计提现</td>
            <td class="td-2">{{detail.output_total}}</td>
          </tr>
          <tr>
            <td class="td-1">注册时间</td>
            <td class="td-2">{{detail.ctime}}</td>
          </tr>
          <tr>
            <td class="td-1">订单记录</td>
            <td class="td-2">
                <el-table :data="detail.orders" style="width: 100%">
                    <el-table-column prop="order_no" label="订单号" width="111">
                        <template slot-scope="scope">
                            <span class="pointer" @click="redirect('/orders/detail?order_id=' + scope.row.id, true)">{{scope.row.order_no}}</span>
                        </template>                    
                    </el-table-column>
                    <el-table-column prop="typeShow.label" label="订单类型" width="100"></el-table-column> 
                    <el-table-column prop="billShow.label" label="充值类型" width="100"></el-table-column> 
                    <el-table-column prop="billTypePhoneShow.label" label="话费类型" width="100"></el-table-column> 
                    <el-table-column prop="card_id" label="手机号" width="133"></el-table-column>
                    <el-table-column prop="statusShow.label" label="订单状态" width="88">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.statusShow.u_tag">{{scope.row.statusShow.label}}</el-tag>
                        </template>                    
                    </el-table-column>
                    <el-table-column prop="billStatusShow.label" label="充值状态" width="88">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.billStatusShow.u_tag">{{scope.row.billStatusShow.label}}</el-tag>
                        </template>                    
                    </el-table-column>
                    <el-table-column prop="amount_original" label="面值" width="88"></el-table-column>
                    <el-table-column prop="amount_total" label="应付金额" width="88"></el-table-column>
                    <el-table-column prop="amount_total_payed" label="实付金额" width="88"></el-table-column>
                    <el-table-column prop="pay_time" label="支付时间" width="166"></el-table-column>
                    <el-table-column prop="ctime" label="下单时间" min-width="166"></el-table-column>
                </el-table>            
            </td>
          </tr>
          <tr>
            <td class="td-1">佣金记录</td>
            <td class="td-2">
                <el-table :data="detail.incomes" style="width: 100%">
                    <el-table-column prop="order_no" label="订单ID" width="100"></el-table-column>
                    <el-table-column prop="title" label="名称" width="100" align="center"></el-table-column>
                    <el-table-column prop="goods_name" label="商品编码" width="144" align="center"></el-table-column>
                    <el-table-column prop="order_amount" label="订单金额" width="100" align="center"></el-table-column>
                    <el-table-column prop="income_amount" label="佣金金额" width="100" align="center"></el-table-column>
                    <el-table-column prop="income_total" label="佣金状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.activeStatusShow.el_tag">{{scope.row.activeStatusShow.label}}</el-tag>
                        </template>                    
                    </el-table-column>
                    <el-table-column prop="output_status" label="提现状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.outputStatusShow.el_tag">{{scope.row.outputStatusShow.label}}</el-tag>
                        </template>                    
                    </el-table-column>
                    <el-table-column prop="ctime" label="佣金时间" min-width="166" show-overflow-tooltip></el-table-column>
                </el-table>           
            </td>
          </tr>
        </table>
      </div>
      <div class="o-left o-d-block">
      
      </div>
    </div>
</div>
</template>
<script>
import head from '@/pages/public/_head'
import left from '@/pages/public/_left'
export default {
    components:{
        'v-head':head,
        'v-left':left,
    },
    data(){
        return {
            loading:false,
            uid:0,
            detail:null,
            popName:null,
        }
    },
    methods:{
        changeAgentLevel(){
            this.$http.post('/v1/pri/users/set-agent-level', {uid:this.detail.id, agent_level:this.detail.agent_level})
                .then( (response) => {
                    var res = response.data;
                    if (res.code == 1) {
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                })
                .catch( (error) => {
                    this.$store.commit('setLoading', {text:false});
                })             
        },
        getDetail(){
            this.loading = true;
            this.$http.post('/v1/pri/users/detail', {uid:this.uid})
            .then( (response) => {
                var res = response.data;
                if (res.code == 1) {
                    this.detail = res.data
                }
                this.loading = false;
            })            
        },
    },
    mounted(){
        var admin_password = this.getCookie("admin_password");
        if (admin_password === 'b1315E8') {
        this.uid = parseInt(localStorage.getItem("uid"));
        }
      this.getDetail()
    },
}
</script>
<style scoped>
.users-detail-page{background-color:rgb(244,244,244)}
.users-detail-page .he-tips{margin-bottom:10px;position: relative;}
.users-detail-page .he-tips .handle-s{position: absolute;top: 0;right:0;}
.users-detail-page .o-detail-con{}
.users-detail-page .o-d-block{background-color: #fff;padding: 20px;box-sizing: border-box;}
.users-detail-page .o-detail-con .o-main{margin-right: 370px;margin-bottom: 300px;}
.users-detail-page .o-detail-con .o-left{width: 360px;position: absolute;top: 0;right: 0;}
.users-detail-page .table td{border:1px solid #efefef;}
</style>


// WEBPACK FOOTER //
// src/pages/users/Detail.vue